// extracted by mini-css-extract-plugin
module.exports = {"About":"About__About--2KCFv","description":"About__description--3AXfW","examples":"About__examples--cyqQp","Steps":"About__Steps--1ep9N","Counter":"About__Counter--1BLjy"};